
import Vue from "vue";

export default Vue.extend({
  data: () => ({
    items: require("@/data/slot/bespokeslot.json"),
  }),
  methods: {
    async launchGame() {
      const isMobile = window.innerWidth <= 768;
      const url =
        "https://sales.globalgames.io/slot-server/api/globojogal/get_launcher_url";

      const data = {
        operator: "MON",
        game: "jokersgold",
        mode: "fun",
        lang: "en",
        channel: isMobile ? "mobile" : "desktop",
        lobby: "https://gg-landingpage.globalgames.io/",
        cashier: "https://gg-landingpage.globalgames.io/",
        jurisdiction: "99",
        currency: "EUR",
        token: "67a658435873960580f72bb5",
        ip: "177.184.136.206",
        user: "67a656a432b22a059f7a0336",
        disallowPromos: false,
      };

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            Token: "b",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });

        const responseData = await response.json();
        if (responseData.error != 0) {
          throw new Error(`HTTP error! Status: ${responseData.error}`);
        }

        if (responseData.result && responseData.result.url) {
          window.open(responseData.result.url, "_blank");
        }
      } catch (error) {
        console.error("Error launching game:", error);
      }
    },
  },
});
